import React, { useRef } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../utils/translations';
import Container from '../common/Container';
import { FaGraduationCap, FaLaptopCode, FaBrain } from 'react-icons/fa';
import useFadeInAnimation from '../../hooks/useFadeInAnimation';
import technologies from '../../Config/Technologies';
import '../../styles/About.css';

const About = () => {
    const { theme } = useTheme();
    const { language } = useLanguage();
    const techRef = useRef(null);
    const t = translations[language].about;

    // Usar el hook personalizado para animación de aparición
    useFadeInAnimation('.tech-item');

    return (
        <section id="about" className={`about ${theme}`}>
            <Container>
                <div className="about-content">
                    <h2 className="section-title">{t.title}</h2>
                    
                    <div className="about-grid">
                        <div className="about-text">
                            <p className="about-description">{t.description}</p>
                            
                            <div className="highlight-cards">
                                <div className="highlight-card">
                                    <div className="highlight-icon-wrapper">
                                        <FaGraduationCap className="highlight-icon" />
                                    </div>
                                    <h3>{t.highlights.education.title}</h3>
                                    <p>{t.highlights.education.description}</p>
                                </div>
                                
                                <div className="highlight-card">
                                    <div className="highlight-icon-wrapper">
                                        <FaLaptopCode className="highlight-icon" />
                                    </div>
                                    <h3>{t.highlights.experience.title}</h3>
                                    <p>{t.highlights.experience.description}</p>
                                </div>
                                
                                <div className="highlight-card">
                                    <div className="highlight-icon-wrapper">
                                        <FaBrain className="highlight-icon" />
                                    </div>
                                    <h3>{t.highlights.methodology.title}</h3>
                                    <p>{t.highlights.methodology.description}</p>
                                </div>
                            </div>
                        </div>

                        <div className="skills-section" ref={techRef}>
                            <div className="tech-showcase">
                                {Object.entries(technologies).map(([category, techs]) => (
                                    <div key={category} className="tech-category">
                                        <h3 className="tech-title">
                                            {t.technologies[category]}
                                        </h3>
                                        <div className="tech-grid">
                                            {techs.map((tech, index) => (
                                                <div 
                                                    key={tech.name} 
                                                    className="tech-item"
                                                    style={{ animationDelay: `${index * 0.1}s` }}
                                                >
                                                    <div className="tech-icon-wrapper">
                                                        <img 
                                                            src={tech.icon} 
                                                            alt={tech.name} 
                                                            className="tech-icon-img"
                                                        />
                                                    </div>
                                                    <span className="tech-name">{tech.name}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default About;